import { render } from "./MatchesView.vue?vue&type=template&id=7f75c7bd&scoped=true"
import script from "./MatchesView.vue?vue&type=script&lang=js"
export * from "./MatchesView.vue?vue&type=script&lang=js"

import "./MatchesView.vue?vue&type=style&index=0&id=7f75c7bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f75c7bd"]])

export default __exports__